import * as React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";

interface Props {
  record: any;
  onClose: () => void;
  onConfirm: () => void;
}

const ToggleStatusDialog: React.FC<Props> = ({ record, onClose, onConfirm }) => (
  <Dialog open={!!record} onClose={onClose} disableRestoreFocus>
    <DialogTitle>{record?.isActive ? "Deactivate Component" : "Activate Component"}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {record?.isActive
          ? `Are you sure you want to deactivate "${record?.pn}" (${record?.ownerCode})?`
          : `Are you sure you want to activate "${record?.pn}" (${record?.ownerCode})?`}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="default">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="primary" variant="contained">
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

export default ToggleStatusDialog;
